import React, { useEffect, useState, useMemo } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AppInsightsContext, ReactPlugin } from '@microsoft/applicationinsights-react-js';
import Demo from './pages/Demo';
import { MobileViewContext } from './context/MobileViewContext.js';
import { MD_SCREEN_SIZE } from './constants';

const { REACT_APP_AI_KEY } = process.env;
let reactPlugin = null;

if (REACT_APP_AI_KEY) {
  reactPlugin = new ReactPlugin();

  const appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: REACT_APP_AI_KEY,
      enableAutoRouteTracking: true,
      extensions: [reactPlugin]
    }
  });
  appInsights.loadAppInsights();
}

const App = () => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= MD_SCREEN_SIZE);

  const handleResize = () => {
    if (window.innerWidth <= MD_SCREEN_SIZE) {
      setIsMobileView(true);
    } else {
      setIsMobileView(false);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isMobileViewProviderValue = useMemo(() => isMobileView, [isMobileView]);

  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      <div className="App">
        <MobileViewContext.Provider value={isMobileViewProviderValue}>
          <Demo />
        </MobileViewContext.Provider>
      </div>
    </AppInsightsContext.Provider>
  );
};

export default App;
